<template>
	<sa-page-layout :showModalLoading="showModalLoading" class="sa-no-space">
		<template slot="toolbar">
			<b-button variant="outline-primary btn-toolbar sa-margin-left float-sm-left" @click="onClickLeggiPratiche">
				<i class="fas fa-cloud-download-alt"></i>
				Carica Pratiche
			</b-button>
		</template>
		<template slot="table-body">
			<siat-lettura-piani-scelta-component ref="cmpSiatLetturaPianiSceltaComponent"></siat-lettura-piani-scelta-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SiatLetturaPianiSceltaComponent from "../components/SiatLetturaPianiSceltaComponent.vue";
export default {
	components: { SaPageLayout, SiatLetturaPianiSceltaComponent },
	data() {
		return {
			showModalLoading: false,
			pathResource: "/dataanalysisdashboard",
			linkback: "/dataanalysisdashboards",
			jsonData: {},
		};
	},
	methods: {
		onClickLeggiPratiche() {
			this.$refs.cmpSiatLetturaPianiSceltaComponent.loadData();
		},
	},
};
</script>
